import { useAppDispatch } from '@/store/hooks'
import { setNewKey } from '@/store/apiKeys/apiKeysSlice'
import { TextMidd, TextSmall } from '@/components/ui/Text'
import Button from '@/components/ui/Button/Button'
import CopyField from '@/components/ui/CopyField/CopyField'
import css from './NewKeyBanner.module.css'

interface NewKeyBannerProps {
    apiKey: string
}

const NewKeyBanner = ({ apiKey }: NewKeyBannerProps) => {
    const dispatch = useAppDispatch()

    const handleDismiss = () => {
        dispatch(setNewKey(null))
    }

    return (
        <div className={css.banner}>
            <TextMidd>Your new API key</TextMidd>
            <TextSmall className={css.note}>
                Copy it now — you won't be able to see it again.
            </TextSmall>
            <div className={css.key_row}>
                <CopyField value={apiKey} mono toastMessage="API key copied" />
            </div>
            <div className={css.dismiss}>
                <Button title="Done" type="black" size="medium" onClick={handleDismiss} />
            </div>
        </div>
    )
}

export default NewKeyBanner
